import { Box, HStack, Text } from '@chakra-ui/react';
import { useAuth } from 'core';
import * as React from 'react';

interface UserProfileProps { }

export const UserProfile = (props: UserProfileProps) => {
  const auth = useAuth();

  const name = `${auth?.user.preferredName || auth?.user.firstName} ${auth?.user.lastName
    }`;

  return (
    <HStack spacing="3" ps="2">
      {/* <Avatar name={name} src={image} boxSize="10" /> */}
      <Box>
        <Text color="on-accent" fontWeight="medium" fontSize="sm">
          {name}
        </Text>
        <Text color="on-accent-muted" fontSize="sm">
          {auth?.user.email}
        </Text>
      </Box>
    </HStack>
  );
};
